export default class CpfStepModel {
  static readonly NOT_FOUND_MESSAGE = 'Nenhum cadastro encontrado para esse CPF.';
  static readonly REQUEST_CODE_LABEL = 'Receber código';
  static readonly LOADING_LABEL = 'Enviando...';

  static sanitizeCpf(cpf: string): string {
    return cpf.replace(/\D/g, '');
  }

  static getRequestCodeLabel(isLoading: boolean): string {
    return isLoading ? CpfStepModel.LOADING_LABEL : CpfStepModel.REQUEST_CODE_LABEL;
  }

  static canRequestCode(isValid: boolean, isLoading: boolean): boolean {
    return isValid && !isLoading;
  }
}
